<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>FOR THE GANG AT<br/>NEW ENGLAND HEALTH &amp; RACQUET</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?c4f7d1f8